<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;background-color: #f5f7f7;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-MainContainer col-12">
        <main class="st-MainContents" style="padding-top:120px;">
          <header class="news-PageTitle">
            <div class="news-PageTitle_Inner">
              <h1 class="sw-Section_Header appear" data-appear>
                <span class="sw-Section_Header-en"><b>SITE POLICY</b></span>
                <span class="sw-Section_Header-ja"><b>サイトポリシー</b></span>
              </h1>
            </div>
          </header>
          <section class="policy-Block">
            <div class="policy-Block_Inner">
              <div>
                <h2>免責事項</h2>
                <p>
                  株式会社ロボティクスソリューションズ、及びその関連会社（以下、「当社」といいます）のウェブサイトからリンクされたサイト・当社ウェブサイトへリンクするサイト(以下「リンクサイト」と呼びます)の内容は、当社の管理下にあるものではありませんので、それぞれのリンクサイトの使用条件に従ってご利用ください。当社はそれらをご利用したことによる損害についても責任を負いません。<br>
                  <br>
                  掲載されている情報のその正確性と最新性の確保に努めていますが、完全さを保証するものではありません。利用者が当ウェブサイトの情報を用いて行う一切の行為について、当社が何ら責任を負うものではありません。また、当ウェブサイトは、予告なしに内容を変更または削除することがありますので、あらかじめご了承ください。
                </p>
              </div>
              <div>
                <h2>著作権</h2>
                <p>
                  当ウェブサイトに収録されている記載事項、写真、動画、音声、製品の説明文章等、すべてのコンテンツの著作権は当社に帰属します。但し、外部依託先の制作や掲載作品等で当社以外に著作者が存在する場合については、原則として各著作者に帰属します。<br>
                  <br>
                  利用者個人で使用（複製、送信、頒布、譲渡、翻案等）する以外に、当ウェブサイトの文章、画像等を他のウェブサイトや印刷媒体に転載することはできません。また、その他著作権法で認められている範囲を超えて、当ウェブサイトに収録されているコンテンツを著作権者に無断で使用することはできません。当社からの事前の書面による承諾なしに、当該情報の無断転用を禁じます。
                </p>
              </div>
              <div>
                <h2>ソーシャルメディア利用に関して</h2>
                <p>ソーシャルメディアから発信する情報は、ソーシャルメディアの特性上、情報の正確性および完全性を保証するものではありません。当社および当社従業員が本アカウントで発信する情報については、必ずしも当社の公式発表・見解を表すものではありません。公式見解・発表は、当ウェブサイトをご覧ください。</p>
              </div>
              <div>
                <h2>準拠法</h2>
                <p>当ウェブサイトは、法律の異なる全世界の国々からアクセスすることが可能ですが、当ウェブサイトにアクセスされたご利用者および当社の両者は、当ウェブサイトの利用に関して日本国の法律に拘束されることに同意するものとします。</p>
              </div>
              <div>
                <h2>禁止事項について</h2>
                <p>当ウェブサイトのご利用に際し、次の行為をしてはならないものとします。</p>
                <ol>
                  <li>1.第三者もしくは当社の財産もしくはプライバシー等を侵害する行為、または侵害する恐れのある行為。</li>
                  <li>2.第三者もしくは当社に、不利益もしくは損害を与える行為、またはその恐れのある行為。</li>
                  <li>3.公序良俗に反する行為、またはその恐れのある行為。</li>
                  <li>4.犯罪行為もしくは犯罪行為に結びつく行為、またはその恐れのある行為。</li>
                  <li>5.他人の電子メールアドレスを登録する等、虚偽の申告、届出を行なう行為。</li>
                  <li>6.営業活動もしくは営利を目的とする行為、またはその準備を目的とする行為。</li>
                  <li>7.第三者もしくは当社の名誉もしくは信用を毀損する行為。</li>
                  <li>8.コンピュータウィルス等有害なプログラムを使用もしくは提供する行為、またはその恐れのある行為。</li>
                  <li>9.その他、法律、法令もしくは条例に違反する行為、またはその恐れのある行為。</li>
                  <li>10.その他、当社が不適切と判断する行為。</li>
                </ol>
              </div>
            </div>
          </section>
        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <a class="st-BreadcrumbsList_Item-link" href="/" itemprop="item">ホーム</a>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">サイトポリシー</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 200) {
            $('.sw-Section_Header').eq(0).removeClass('appear')
          } else {
            $('.sw-Section_Header').eq(0).addClass('appear')
          }
        } else {
        }
      })
    }
  }
}
</script>
<style scoped>
.home >>> .st-Nav_List-en {
  color: #222;
}

.home >>> .st-Nav_List-ja {
  color: #222;
}
.home >>> .st-Header {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  transition: height 0.2s ease-in-out;
}

a {
  border-bottom-style: none;
}

.sw-ButtonRound a {
  padding: 18px 50px;
  min-width: 160px;
  background-color: #c7000b;
}

.sw-ButtonRound a span {
  margin-left: -25px;
}

.sw-ButtonRound a span,
.sw-ButtonRound a i {
  background-color: #c7000b;
  color: #ffffff;
}

.news-Narrow >>> .el-input__inner {
  border-radius: 100px;
  width: 120px;
  border-color: #04192a;
}

.is-active {
  background-color: #04192a !important;
}

.top-card_Image-inner img {
  width: 100%;
}

.swiper-slide-news {
  width: 360px !important;
  margin-right: 60px !important;
  margin-left: 36px !important;
}

.news-Narrow_Cate li {
  border-radius: 100px;
}

.news-Narrow_Cate li a {
  transition: none;
  border-radius: 100px;
}

@media (hover: hover) {
  .news-Narrow_Cate li a:hover {
    border-radius: 100px;
    transition: none;
  }
}
.sw-Section_Header-en {
  font-size: 32px;
}
.sw-Section_HeaderS-ja {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/policy/policy.vue